import { IOrganization } from "@/api";
import NewUser from "@/components/admin/dialogs/new-user-dialog/NewUser";
import { Button } from "@/components/shared/buttons/Button";
import { useDialogs } from "@toolpad/core";

interface IProps {
    /** The organization to add a new user to */
    organization: IOrganization;
}

/**
 * A button that adds a new user to an organization
 */
export const AddNewUserButton = ({ organization }: IProps) => {
    const dialogs = useDialogs();

    const handleClick = () => {
        dialogs.open(NewUser, {
            organization,
        });
    };

    return (
        <Button
            variant="contained"
            color="secondary"
            sx={{ borderRadius: 29 }}
            disableElevation
            onClick={handleClick}
        >
            Add New User
        </Button>
    );
};
